export function parseNumber(value: string | null | undefined, default_: number): number {
    if(value) {
        return Number(value)
    } else {
        return default_
    }
}

export const drawerWidth = 100;
export const cartDrawerWidth = 320;